import { useEffect } from "react";
import { Box, Button, CloseButton, Dialog, HStack, Portal, Text } from "@chakra-ui/react";
import { Field, FormTextarea } from "@/components/jobOffer/ui";

// Lead's TimelineKind enum only exposes one user-authorable value ("ManualEntry") --
// the rest (Created/Initialized/StatusChange/Note/Qualified/ConversionProposed/HandedToHuman)
// are written automatically by the system, so there's no kind-picker here unlike Candidate's.
const AddLeadTimelineEntryModal = ({ isOpen, onClose, description, setDescription, occurredAt, setOccurredAt, onSubmit, isLoading }) => {
    useEffect(() => {
        if (isOpen) setOccurredAt(new Date().toISOString().slice(0, 16));
    }, [isOpen, setOccurredAt]);

    return (
        <Dialog.Root open={isOpen} onOpenChange={(e) => { if (!e.open) onClose(); }}>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner p={4}>
                    <Dialog.Content
                        bg="white" color="gray.900" borderColor="gray.200" border="1px solid"
                        boxShadow="0 4px 24px rgba(23,21,31,0.12)"
                        w={{ base: "calc(100vw - 2rem)", md: "lg" }} maxW="100%" maxH="calc(100dvh - 2rem)"
                        overflowY="auto" borderRadius={12}
                    >
                        <Dialog.Body pt={6} pb={6} px={6}>
                            <Text fontWeight={700} fontSize="lg" color="gray.900" mb={4}>Dodaj wpis w osi czasu</Text>
                            <Field label="Data zdarzenia">
                                <Box>
                                    <input
                                        type="datetime-local"
                                        value={occurredAt}
                                        onChange={(e) => setOccurredAt(e.target.value)}
                                        style={{
                                            width: "100%", background: "white",
                                            border: "1px solid var(--chakra-colors-gray-200, #e2e8f0)",
                                            borderRadius: "8px", color: "var(--chakra-colors-gray-900, #1a202c)", padding: "8px 12px", fontSize: "14px",
                                            colorScheme: "light",
                                        }}
                                    />
                                </Box>
                            </Field>
                            <Box mt={4}>
                                <Field label="Opis">
                                    <FormTextarea
                                        placeholder="Co się wydarzyło..."
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        rows={4}
                                        resize="vertical"
                                    />
                                </Field>
                            </Box>
                            <HStack justify="flex-end" gap={2} mt={4}>
                                <Button variant="ghost" size="sm" onClick={onClose} disabled={isLoading}>Anuluj</Button>
                                <Button variant="primary" size="sm" loading={isLoading} disabled={!description.trim()} onClick={onSubmit}>
                                    Dodaj
                                </Button>
                            </HStack>
                        </Dialog.Body>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="sm" position="absolute" top="2" right="2" color="gray.400" _hover={{ color: "gray.600", bg: "gray.100" }} />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};

export default AddLeadTimelineEntryModal;
